/**
 * IBA Access Control Constants
 * Centralized constants for IBA (Important Bird and Biodiversity Areas) access control
 */

// KBA Partner IDs that have IBA access when their country has iba_active = true
export const IBA_ELIGIBLE_KBA_PARTNERS = [1, 3, 11] // American Bird Conservancy, BirdLife International, RSPB

// KBA Partner names for display purposes
export const IBA_ELIGIBLE_KBA_PARTNER_NAMES = [
  'American Bird Conservancy', 
  'BirdLife International', 
  'Royal Society for the Protection of Birds'
]

// IBA Access Levels
export const IBA_ACCESS_LEVELS = {
  FULL: 'full',      // Can see all IBA features and data
  LIMITED: 'limited', // Can see IBA fields in sites management but with blank/dash data
  NONE: 'none'       // Cannot see any IBA features
}

// IBA Feature Types
export const IBA_FEATURES = {
  SITES_MANAGEMENT: 'sitesManagement',
  CONGREGATIONS: 'congregations', 
  SPECIES_FIELDS: 'speciesFields',
  CRITERIA: 'criteria'
}

// IBA Data Display Options
export const IBA_DATA_DISPLAY = {
  SHOW_DATA: 'show',     // Show actual data
  SHOW_DASH: 'dash',     // Show dash (-)
  HIDE: 'hide'           // Don't show field at all
}
